import { Account, AccountInfo, Partner, ProductsWithEligibility, ShopStatus } from 'src/api/@generated/backend';

export enum RequestStatus {
  IDLE = 'IDLE',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export interface Request<T extends Resource> {
  data?: T;
  status: RequestStatus;
}

export enum RequestType {
  GET_ACCOUNTS = 'GET_ACCOUNTS',
  GET_PARTNERS = 'GET_PARTNERS',
  GET_ACCOUNT_INFO = 'GET_ACCOUNT_INFO',
  GET_SHOP_STATUS = 'GET_SHOP_STATUS',
  GET_PRODUCTS_WITH_ELIGIBILITY = 'GET_PRODUCTS_WITH_ELIGIBILITY',
}

export interface RequestState {
  [RequestType.GET_ACCOUNTS]: Request<Account[]>;
  [RequestType.GET_PARTNERS]: Request<Partner[]>;
  [RequestType.GET_ACCOUNT_INFO]: Request<AccountInfo>;
  [RequestType.GET_SHOP_STATUS]: Request<ShopStatus>;
  [RequestType.GET_PRODUCTS_WITH_ELIGIBILITY]: Request<ProductsWithEligibility>;
}

export type Resource = Account[] | ShopStatus | AccountInfo | Partner[] | ProductsWithEligibility;
